import { formatNumberAsThousands } from '../../../../../utils/priceHelpers'
import ChartBox from '../ChartBox/index'
import { ReactComponent as GuestsIcon } from './guests.svg'
import { ReactComponent as NightsIcon } from './nights.svg'
import { ReactComponent as RevenueIcon } from './revenue.svg'
import styles from './Summary.module.scss'

const Fact = ({ icon, value, description }) => (
  <div className={styles.fact}>
    <div className={styles.factIcon}>{icon}</div>
    <div className={styles.factContent}>
      <div className={styles.factNumber}>{value}</div>
      <div className={styles.factDesc}>{description}</div>
    </div>
  </div>
)

const Summary = ({ numberOfGuests, totalRevenue, totalNights }) => (
  <div className={styles.wrapper}>
    <ChartBox>
      <div className={styles.summary}>
        <Fact
          icon={<GuestsIcon />}
          value={numberOfGuests.toLocaleString('en-US')}
          description="guests reclaimed"
        />
        <Fact
          icon={<RevenueIcon />}
          value={`$${formatNumberAsThousands(totalRevenue)}`}
          description="revenue generated"
        />
        <Fact
          icon={<NightsIcon />}
          value={totalNights.toLocaleString('en-US')}
          description="total nights"
        />
      </div>
    </ChartBox>
  </div>
)

export default Summary
